import { render, staticRenderFns } from "./BarGraphRangeInput.vue?vue&type=template&id=38ac54fe&scoped=true&"
import script from "./BarGraphRangeInput.vue?vue&type=script&lang=ts&"
export * from "./BarGraphRangeInput.vue?vue&type=script&lang=ts&"
import style0 from "./BarGraphRangeInput.vue?vue&type=style&index=0&id=38ac54fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac54fe",
  null
  
)

export default component.exports